const prod = {
  API_URL: process.env.REACT_APP_PROD_URL,
};

const dev = {
  API_URL: process.env.REACT_APP_DEV_URL,
};
export const mainUrl = process.env.NODE_ENV === "development" ? dev : prod;
